import type { IconFactor } from '@/types/elements/icon'
import type { IInputOption, IInputProps } from '../form/input/types'
import type { CSSProperties } from 'vue'
import type { FormFieldOption } from '@/form/useForm'

export const ONE_REM = 16
export const ITEM_HEIGHT_REM = 42 / ONE_REM
export const MAX_VISIBLE_ITEMS = 4

export type SelectDropDownConfig = {
  itemListPlacement?: 'default' | 'left' | 'right' | 'center';
  collapseIcon?: IconFactor;
  itemHeight?: number;
  noCollapseIconWhenDisabled?: boolean;
  invalidValuePlaceholder?: IInputOption | FormFieldOption;  
  noOpacityChangeWhenDisabled?: boolean;
}

export type SelectDropDownProps = Partial<IInputProps> & {
  hiddenWhenCollapsed?: boolean
  noCollapseIconWhenDisabled?: boolean;
  noOpacityChangeWhenDisabled?: boolean;
  expanded?: boolean
  size?: string;
  onValueChange?: (value: any) => void | Promise<void>;
  icon?: IconFactor;
  itemStyleExpanded?: CSSProperties;
  itemStyleCollapsed?: CSSProperties;
  itemListMinWidth?: string;
  small?: boolean;
  config?: SelectDropDownConfig;
  noSelect?: boolean;
}

export type SelectDropDownState = {
  expanded: boolean
  value: any;
  //selectedIndex: number;
  searchString?: string
  addedItems: IInputOption[]
  loading: boolean
}
